import { usePage } from "@inertiajs/react";
import Container from "hardcover-ui/components/Container";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import BookLayout from "features/books/layouts/BookLayout/BookLayout";
import Pagination from "components/shared/Pagination";
import { BookCharactersPageProps } from "./index.props";
import BookPromptGroup from "components/BookGroup/groups/BookPromptGroup";

function PromptsIndex() {
  const { book, prompts } = usePage<BookCharactersPageProps>().props;

  return (
    <BookLayout>
      <Container variant="layout" size="md">
        {prompts.map((prompt) => (
          <BookPromptGroup
            key={`book-prompt-${prompt.id}`}
            prompt={prompt}
            activeBook={book}
            size={prompt.featured ? "lg" : "md"}
            context={{ maxBooks: 12 }}
            className="py-6 lg:py-8 border-b border-gray-200 dark:border-gray-700"
          />
        ))}
        <Pagination />
      </Container>
    </BookLayout>
  );
}

PromptsIndex.layout = DefaultLayoutWrapper;
export default PromptsIndex;